import { render } from "./CreatePurchasePage.vue?vue&type=template&id=64395881&ts=true"
import script from "./CreatePurchasePage.vue?vue&type=script&lang=ts"
export * from "./CreatePurchasePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__